import React from 'react';
import Layout from '../components/layout/Layout';
import '../styles/CompanyPage.css';

const CompanyPage = () => {
  return (
    <Layout>
      <div className="company-page">
        <div className="container">
          <h1 className="page-title">会社情報</h1>
          
          <section className="company-overview">
            <h2 className="section-title">会社概要</h2>
            <table className="info-table">
              <tbody>
                <tr>
                  <th>会社名</th>
                  <td>株式会社むつび</td>
                </tr>
                <tr>
                  <th>設立</th>
                  <td>2025年7月</td>
                </tr>
                <tr>
                  <th>代表取締役</th>
                  <td>畑迫 睦和</td>
                </tr>
                <tr>
                  <th>所在地</th>
                  <td>〒150-0043 東京都渋谷区道玄坂１丁目１０番８号渋谷道玄坂東急ビル２Ｆ－Ｃ</td>
                </tr>
                <tr>
                  <th>事業内容</th>
                  <td>
                    システムエンジニアリングサービス（SES）事業<br />
                    受託開発（請負）事業<br />
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

        </div>
      </div>
    </Layout>
  );
};

export default CompanyPage;
